



















import { Vue, Component, } from 'vue-property-decorator'
import DialogSlot from '@/components/dialog/doalogSlot.vue'
import FormItem from '@/components/formItem/index.vue'
import TsForm from '@/components/TsForm/index.vue'
import outPageCom from '@/views/newPension/pensionCard/investCard/coms/outPageCom.vue'
import { earnPreview } from '@/api/card/investCard'
import {
  SaveInvestPro,
  EarnChartRes
} from '@/types/card/investCard'
@Component({
  components: {
    DialogSlot,
    TsForm,
    FormItem,
    outPageCom
  },
})
export default class extends Vue {
  dialogShow = false
  dataObj: EarnChartRes = {
    autoInvestActions: [],
    singleActions: [],
    investmentGraph: {
      categoryPercentages: []
    },
    prospectiveEarnings: {
      annualRateOfReturn: 0,
      createBy: '',
      createByName: '',
      createTime: '',
      deleted: false,
      earningsInterval: '',
      id: '',
      maxDrawback: 0,
      riskType: '',
      standardDeviation: 0,
      tenantId: '',
    },
    earningsForecastLineChart: {
      dots: []
    },
    totalGap: 0,
    productSupplyAmount: 0
  }

  async onEarnPreview (data: object) {
    // data.autoInvestActions = JSON.stringify(data.autoInvestActions)
    // data.singleActions = JSON.stringify(data.singleActions)
    const ret = await earnPreview(data)
    if (ret.statusCode === 0 && ret.data) {
      this.dataObj = ret.data
    }
  }

  handleConfirm () {
    this.dialogShow = false
  }

  show (data: SaveInvestPro) {
    console.log('data', data)
    this.dialogShow = true
    this.onEarnPreview(data)
  }

  handleClose () {
    this.dialogShow = false
  }
}
